import React, { useEffect, useState } from 'react'; 
import Sidebar from './Sidebar'; 
import axios from 'axios';
import { BASE_URL } from './../../Environment';
import { toast } from 'react-toastify';
import Info from './Info';
import styles from './../../Assets/CSS/Register.module.css';
import inputStyles from './../../Assets/CSS/Input.module.css';
import { BlueButton } from './../../Components/Button';
import { useNavigate, useParams } from 'react-router-dom';

function ListingUpdate() {
    const { id } = useParams();
    const navigate = useNavigate();
    const accessToken = localStorage.getItem('accessToken');
    const [isLoading, setIsLoading] = useState(false);
    const [isCreateLoading, setIsCreateLoading] = useState(false);
    const [category_id, setCategoryId] = useState('');
    const [sub_category_id, setSubCategoryId] = useState('');
    const [sub_sub_category_id, setSubSubCategoryId] = useState('');
    const [name, setName] = useState(''); 
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [whatsapp, setWhatsapp] = useState('');
    const [description, setDescription] = useState('');
    const [highlight, setHighlight] = useState('');
    const [website, setWebsite] = useState('');
    const [facebook, setFacebook] = useState('');
    const [instagram, setInstagram] = useState('');
    const [house_no, setHouseNo] = useState('');
    const [road_name, setRoadName] = useState('');     
    const [pincode, setPincode] = useState('');
    const [district, setDistrict] = useState('');
    const [state, setState] = useState('');
    const [country, setCountry] = useState(''); 
    const [landmark, setLandmark] = useState('');  
    const [license_no, setLicenseNo] = useState('');
    const [license_upload, setLicenseUpload] = useState(null); 
    const [category, setCategory] = useState([]);
    const [sub_category, setSubCategory] = useState([]);
    const [sub_sub_category, setSubSubCategory] = useState([]);
    useEffect(() => {
        document.title = 'Infomart | Client Listing Update';
        setIsLoading(true);
        axios.get(`${BASE_URL}/vendor/get-category`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        }).then((res) => {
            setCategory(res.data.data);
            setIsLoading(false);
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
            setIsLoading(false);
        });
        axios.post(`${BASE_URL}/vendor/listing/details`, { id }, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        }).then((res) => {
            setCategoryId(res.data.data.category_id);
            setSubCategoryId(res.data.data.sub_category_id);
            setSubSubCategoryId(res.data.data.sub_sub_category_id);
            setName(res.data.data.name); 
            setEmail(res.data.data.email);
            setPhone(res.data.data.phone);
            setWhatsapp(res.data.data.whatsapp);
            setDescription(res.data.data.description);
            setHighlight(res.data.data.highlight);
            setWebsite(res.data.data.website);
            setFacebook(res.data.data.facebook);
            setInstagram(res.data.data.instagram); 
            setHouseNo(res.data.data.house_no);
            setRoadName(res.data.data.road_name); 
            setPincode(res.data.data.pincode);
            setDistrict(res.data.data.district);
            setState(res.data.data.state);
            setCountry(res.data.data.country); 
            setLandmark(res.data.data.landmark); 
            setLicenseNo(res.data.data.license_no);  
            const category_id = res.data.data.category_id; 
            const sub_category_id = res.data.data.sub_category_id;  
            axios.post(`${BASE_URL}/vendor/listing/get-sub-category`, { category_id }, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${accessToken}`
                }
            }).then((res) => {
                setSubCategory(res.data.data);
            }).catch((res) => {
                toast.error(res.response.data.msg, { autoClose: 3000 });
            });
            axios.post(`${BASE_URL}/vendor/listing/get-sub-sub-category`, { sub_category_id }, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${accessToken}`
                }
            }).then((res) => {
                setSubSubCategory(res.data.data);
            }).catch((res) => {
                toast.error(res.response.data.msg, { autoClose: 3000 });
            });
            setIsLoading(false); 
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
            setIsLoading(false);
        }); 
    }, []);
    const handleCategory = (id) => {
        setCategoryId(id);
        setSubCategory([]); 
        setSubSubCategory([]);  
        setSubCategoryId('');
        setSubSubCategoryId('');
        axios.post(`${BASE_URL}/vendor/get-sub-category`, { id }, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        }).then((res) => {
            setSubCategory(res.data.data);
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
        });
    }
    const handleSubCategory = (id) => {
        setSubCategoryId(id);
        setSubSubCategory([]);  
        setSubSubCategoryId('');
        axios.post(`${BASE_URL}/vendor/get-sub-sub-category`, { id }, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            } 
        }).then((res) => {
            setSubSubCategory(res.data.data);
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
        });
    }
    const handleSubmit = async () => {
        setIsCreateLoading(true);
        const formData = new FormData();
        const fields = { id, category_id, sub_category_id, sub_sub_category_id, name, email, phone, whatsapp, description, highlight, website, facebook, instagram, house_no, road_name, pincode, district, state, country, landmark, license_no };
        Object.keys(fields).forEach(key => formData.append(key, fields[key]));
        if (license_upload) formData.append('license_upload', license_upload);
        await axios.post(`${BASE_URL}/vendor/listing/update`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${accessToken}`
            } 
        }).then((res) => {
            toast.success(res.data.msg, { autoClose: 3000 });
            setIsCreateLoading(false);
            navigate('/client/listing');
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
            setIsCreateLoading(false);
        });
    }
    return (
        <div className="app"> 
            <div className="outlet">
                <Info />
                <div className="homeLayout">
                    <Sidebar />
                    {isLoading ?
                        <h5 className="text-center mt-5">Loading...</h5>
                        :
                        <div className={styles.individualFormContainer} style={{ width: '100%', marginBottom: 0 }}>
                            <div className={styles.top}>
                                <div className="w-100">
                                    <h4 className="text-left">Update Listing</h4>
                                </div> 
                            </div>
                            <div className={styles.row}>
                                <select className={inputStyles.dropdown} value={category_id} onChange={e => handleCategory(e.target.value)}>
                                    <option value="" selected disabled>Select Category *</option>
                                    {category.map((data, i) => (
                                        <option key={i} value={data.id}>{data.name}</option>
                                    ))}
                                </select>
                                <select className={inputStyles.dropdown} value={sub_category_id} onChange={e => handleSubCategory(e.target.value)}>
                                    <option value="" selected disabled>Select Sub Category *</option>
                                    {sub_category.map((data, i) => (
                                        <option key={i} value={data.id}>{data.name}</option>
                                    ))}
                                </select>
                                <select className={inputStyles.dropdown} value={sub_sub_category_id} onChange={e => setSubSubCategoryId(e.target.value)}>
                                    <option value="" selected disabled>Select Sub Sub Category *</option>
                                    {sub_sub_category.map((data, i) => (
                                        <option key={i} value={data.id}>{data.name}</option>
                                    ))}
                                </select>
                            </div>
                            <div className={styles.row}>
                                <>
                                    <input type="text" className={inputStyles.input} value={name} placeholder="Enter Listing Name *" onChange={e => setName(e.target.value.toUpperCase())} style={{ textTransform: 'uppercase' }} />
                                    <style> 
                                        {`
                                            input::placeholder {
                                                text-transform: none;
                                            } 
                                        `}  
                                    </style> 
                                </>   
                                <input type="email" className={inputStyles.input} value={email} placeholder="Enter Email ID *" onChange={e => setEmail(e.target.value)} />
                            </div>
                            <div className={styles.row}>
                                <input type="number" className={inputStyles.input} value={phone} placeholder="Enter Phone No. *" onChange={e => setPhone(e.target.value)} />
                                <input type="number" className={inputStyles.input} value={whatsapp} placeholder="Enter WhatsApp No. *" onChange={e => setWhatsapp(e.target.value)} />
                            </div>
                            <div className={styles.row}>
                                <input type="text" className={inputStyles.input} value={website} placeholder="Enter Website (Optional)" onChange={e => setWebsite(e.target.value)} />
                                <input type="text" className={inputStyles.input} value={facebook} placeholder="Enter Facebook (Optional)" onChange={e => setFacebook(e.target.value)} />
                                <input type="text" className={inputStyles.input} value={instagram} placeholder="Enter Instagram (Optional)" onChange={e => setInstagram(e.target.value)} />
                            </div> 
                            <textarea className={inputStyles.input} value={description} placeholder="Enter Description *" onChange={e => setDescription(e.target.value)} />
                            <textarea className={inputStyles.input} value={highlight} placeholder="Enter Highlight *" onChange={e => setHighlight(e.target.value)} />
                            <div className={styles.row}>  
                                <input type="text" className={inputStyles.input} value={house_no} placeholder="Enter House No." onChange={e => setHouseNo(e.target.value)} />
                                <input type="text" className={inputStyles.input} value={road_name} placeholder="Enter Road Name *" onChange={e => setRoadName(e.target.value)} />
                            </div>    
                            <div className={styles.row}> 
                                <input type="number" className={inputStyles.input} value={pincode} placeholder="Enter Pincode *" onChange={e => setPincode(e.target.value)} />
                                <input type="text" className={inputStyles.input} value={district} placeholder="Enter District *" onChange={e => setDistrict(e.target.value)} /> 
                            </div> 
                            <div className={styles.row}>
                                <input type="text" className={inputStyles.input} value={state} placeholder="Enter State *" onChange={e => setState(e.target.value)} />
                                <input type="text" className={inputStyles.input} value={country} placeholder="Enter Country *" onChange={e => setCountry(e.target.value)} /> 
                            </div>   
                            <textarea className={inputStyles.input} value={landmark} placeholder="Enter Landmark (Optional)" onChange={e => setLandmark(e.target.value)} />  
                            <input type="text" className={inputStyles.input} value={license_no} placeholder="Enter License No. (Optional)" onChange={e => setLicenseNo(e.target.value)} />
                            <input type="file" className={inputStyles.input} accept=".pdf,.jpg,.jpeg,.png" onChange={e => setLicenseUpload(e.target.files[0])} /> 
                            <div className="mt-4"> 
                                <BlueButton title={isCreateLoading ? "Loading..." : "Submit"} onClick={() => handleSubmit()} />
                            </div>
                        </div>
                    }
                </div>
            </div> 
        </div>
    );
}

export default ListingUpdate;             